var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTacPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 53.336,
    height: 53.336,
    viewBox: "0 0 53.336 53.336",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_233",
    "data-name": "Rectangle 233",
    width: 53.336,
    height: 53.336,
    rx: 15,
    transform: "translate(0)",
    fill: "#e0057f",
    opacity: 0.3
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_234",
    "data-name": "Rectangle 234",
    width: 25.54,
    height: 30.008,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_331",
    "data-name": "Groupe 331",
    transform: "translate(49.221 -2831.056)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_de_masques_5",
    "data-name": "Groupe de masques 5",
    transform: "translate(-49.221 2831.056)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_232",
    "data-name": "Rectangle 232",
    width: 53.336,
    height: 53.336,
    transform: "translate(0 0)",
    fill: "#e0057f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_218",
    "data-name": "Groupe 218",
    transform: "translate(-13.996 2847.799)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_12",
    "data-name": "Ellipse 12",
    d: "M4.127,1A3.127,3.127,0,1,0,7.254,4.127,3.131,3.131,0,0,0,4.127,1m0-1A4.127,4.127,0,1,1,0,4.127,4.127,4.127,0,0,1,4.127,0Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_297",
    "data-name": "Trac\\xE9 297",
    d: "M2.4.517h0L0,.5A.5.5,0,0,1-.5,0,.5.5,0,0,1,0-.5l2.4.017a.5.5,0,0,1,0,1Z",
    transform: "translate(2.871 4.118)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_298",
    "data-name": "Trac\\xE9 298",
    d: "M2.4.517h0L0,.5A.5.5,0,0,1-.5,0,.5.5,0,0,1,0-.5l2.4.017a.5.5,0,0,1,0,1Z",
    transform: "translate(4.08 2.926) rotate(90)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_220",
    "data-name": "Groupe 220",
    transform: "translate(-35.323 2847.799)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_219",
    "data-name": "Groupe 219",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_299",
    "data-name": "Trac\\xE9 299",
    d: "M155.277,113.877q-.27,0-.542-.017a8.1,8.1,0,0,1-7.064-10.9.571.571,0,0,1,.077-.3l.174-.3a8.117,8.117,0,0,1,.724-1.25l6.27-10.825.011-.026a2.7,2.7,0,0,0,.1-.271.57.57,0,0,1,1.072-.112l.163.346,6.54,12.458a.57.57,0,0,1,.065.279,8.1,8.1,0,0,1-7.593,10.918m-6.424-10.85a.569.569,0,0,1-.036.132,6.928,6.928,0,0,0-.468,3.38,7.015,7.015,0,0,0,6.459,6.182,6.963,6.963,0,0,0,6.915-9.561.57.57,0,0,1-.039-.158L155.591,91.4,149.62,101.7c-.009.015-.018.03-.028.044a6.971,6.971,0,0,0-.645,1.113q-.011.024-.024.047Z",
    transform: "translate(-137.834 -83.87)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_300",
    "data-name": "Trac\\xE9 300",
    d: "M7.269,22.746a.577.577,0,0,1-.106-.01C3.522,22.056,1.24,20.458.382,17.989-.607,15.143.328,11.268,3.16,6.473A46.646,46.646,0,0,1,7.636.2a.571.571,0,0,1,.91.066l5.147,7.975a.571.571,0,0,1-.959.619L8.008,1.533C6.138,3.836-.363,12.37,1.46,17.615c.714,2.054,2.7,3.4,5.913,4a.571.571,0,0,1-.1,1.132",
    transform: "translate(0 -0.001)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "TAC",
    d: "M2.342,8.132a.236.236,0,0,1-.044,0A.205.205,0,0,1,2.22,8.1a.231.231,0,0,1-.034-.028Q2.123,8,2.123,7.913V2.853H.43q-.091,0-.156-.064T.21,2.634V1.957q0-.1.064-.165T.43,1.728H5.1q.1,0,.165.064t.064.165v.677q0,.091-.064.156T5.1,2.853H3.413V7.913q0,.091-.064.156a.216.216,0,0,1-.034.028.208.208,0,0,1-.039.02.228.228,0,0,1-.043.012.278.278,0,0,1-.048,0Zm2.845,0a.185.185,0,0,1-.036,0,.179.179,0,0,1-.034-.01A.2.2,0,0,1,5.085,8.1a.235.235,0,0,1-.031-.024Q5,8.022,5,7.94q0-.037.018-.082l2.2-5.9q.027-.091.105-.16t.215-.069h1q.137,0,.21.069t.11.16l2.2,5.9q.009.046.009.082,0,.082-.055.137a.208.208,0,0,1-.029.024.176.176,0,0,1-.031.017.167.167,0,0,1-.033.01.18.18,0,0,1-.035,0h-.8a.451.451,0,0,1-.06,0,.3.3,0,0,1-.051-.011A.211.211,0,0,1,9.938,8.1.166.166,0,0,1,9.9,8.073q-.059-.059-.078-.114L9.4,6.842H6.679l-.43,1.116q-.018.055-.078.114a.166.166,0,0,1-.034.026.211.211,0,0,1-.043.019.3.3,0,0,1-.051.011.451.451,0,0,1-.06,0ZM7,5.79H9.076L8.033,2.963Zm7.264,2.434q-.851,0-1.441-.3t-.9-.851q-.311-.553-.348-1.331-.009-.375-.009-.805t.009-.823q.037-.768.352-1.327t.906-.855q.59-.3,1.432-.3.622,0,1.116.165t.842.453q.348.288.54.672t.2.833q.009.082-.05.137t-.142.055H15.9q-.1,0-.165-.05t-.091-.169q-.146-.6-.5-.823t-.887-.22q-.613,0-.979.343t-.393,1.13q-.027.75,0,1.537t.393,1.13q.366.343.979.343.531,0,.887-.224t.5-.819q.027-.128.091-.174t.165-.046h.869q.082,0,.142.055t.05.137q-.009.448-.2.833t-.54.672q-.348.288-.842.453T14.263,8.224Z",
    transform: "translate(-32.299 2833.937)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTacPlus);
export default __webpack_public_path__ + "static/media/TAC_PLUS.e3135ff3e47380dc6cd3f4ba8327ee8b.svg";
export { ForwardRef as ReactComponent };